import { MapView,  BtnMyLocation, SearchBar } from "../components"
export const HomePage = () => {
  return (
  
        <>
        <MapView/>
        <BtnMyLocation/>
        <SearchBar/>
        </>
  
  )
}